import * as React from 'react';
import { Button, ModalWindow, Radio } from '@cian/ui-kit';

import { IDialogFilterItem } from '../../../../types/filterSelectors';

interface IFiltersModalProps {
  filters: IDialogFilterItem[];
  open: boolean;
  title: string;
  onClose: () => void;
  onFilter: (item: IDialogFilterItem) => void;
}

export const FiltersModal: React.FC<IFiltersModalProps> = ({ filters, open, title, onClose, onFilter }) => {
  const defaultSelectedItem = React.useMemo<IDialogFilterItem | undefined>(
    () => filters.find(item => item.isActive) || filters[0],
    [filters],
  );
  const [selectedItem, setSelectedItem] = React.useState<IDialogFilterItem | undefined>(defaultSelectedItem);

  React.useLayoutEffect(() => {
    if (open) {
      setSelectedItem(defaultSelectedItem);
    }
  }, [open, defaultSelectedItem]);

  const handleItemSelect = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const item = filters[Number(event.target.value)];
      setSelectedItem(item);
    },
    [filters],
  );

  const handleButtonClick = React.useCallback(
    () => onFilter(selectedItem as IDialogFilterItem),
    [onFilter, selectedItem],
  );

  if (!selectedItem) {
    return null;
  }

  return (
    <ModalWindow
      fixed
      open={open}
      title={title}
      content={
        <>
          {filters.map((item, index) => (
            <Radio
              key={index}
              checked={selectedItem === item}
              name="mortgage"
              label={item.name}
              value={String(index)}
              onChange={handleItemSelect}
            />
          ))}
        </>
      }
      footer={
        <Button size="L" fullWidth onClick={handleButtonClick}>
          {selectedItem.countText}
        </Button>
      }
      onClose={onClose}
    />
  );
};
